<template>
  <DropdownMultipleSelectMenuButton
    :value="_normalizedValue"
    remindText="紅字為無權限"
    :title="title"
    :rules="rules"
    :outline="outline"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
    :noErrorText="noErrorText"
    :menuItems="_systemClassMenu"
    :hasCancelIcon="hasCancelIcon"
    @input="$emit('input', $event)"
  />
</template>

<script>
import S_systemClass from '@/service/api/v1/system_class';

export default {
  props: {
    value: {
      type: Array,
      default: undefined,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    rules: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasCancelIcon: {
      type: Boolean,
      default: false,
    },
    noErrorText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _normalizedValue() {
      return Array.isArray(this.value) ? this.value : [];
    },
    _systemClassMenu() {
      const list = this.$store.state.model.systemClasses || [];
      return S_systemClass.setSystemClassesItems(list);
    },
  },
};
</script>
